// @flow

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../components/mui/app/pageTitle/pageTitle";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import ChecklistsList from "../../modules/issues/components/nonCompletedChecklists/checklistsList";

type Props = {

};

const UserQuestionnaireHistory = (props: Props) => {
	const { t } = useTranslation(CHECKLISTS)
	
	return (
		<Box className={'non_completed_checklist_index'}>
			<PageContentWrapper>
				<PageTitle title={t("Questionnaire History")}/>
				<ChecklistsList  Finalization={'0'} url={'custom/goodtohave/checklist/index'}  showReferenceDt={true}/>
			</PageContentWrapper>
		</Box>
	);

};

export default UserQuestionnaireHistory